/**
 * Campaign statistics.
 *
 * Rates are computed against *delivered* emails, not the audience size: a
 * campaign still draining the outbox would otherwise show a collapsing open
 * rate as more emails go out.
 */
define('mailingCampaignDetailView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'marionette',
  'mailingShell',
  'entities/mailing'
], function (
  module,
  App,
  _,
  $,
  Marionette,
  Shell,
  MailingApi
) {
  'use strict';

  var CampaignDetailView = Marionette.ItemView.extend({

    className: 'mailing-page mailing-campaign-detail',

    template: _.template(
      '<%= nav %>' +
      '<div class="mlg-body"><div class="mlg-loading">Loading campaign…</div></div>'
    ),

    ui: {
      body: '.mlg-body'
    },

    events: {
      'click .mlg-back': 'onBack',
      'click .mlg-refresh': 'load'
    },

    initialize: function (options) {
      this.secId = options.secId;
    },

    serializeData: function () {
      return {
        nav: Shell.navHtml('campaigns',
          '<button type="button" class="mlg-btn mlg-refresh">Refresh</button>' +
          '<a class="mlg-btn mlg-back" href="#mailing/campaigns">Back to list</a>')
      };
    },

    onShow: function () {
      this.load();
    },

    load: function () {
      var self = this;
      $.when(MailingApi.campaign(this.secId), MailingApi.campaignStats(this.secId))
        .done(function (campaign, stats) {
          self.renderDetail(campaign, stats);
        })
        .fail(function (xhr) {
          self.ui.body.html('<div class="mlg-error">' +
            _.escape(MailingApi.errorMessage(xhr)) + '</div>');
        });
    },

    renderDetail: function (campaign, stats) {
      var tiles = [
        { label: 'Queued', value: Shell.formatNumber(stats.total) },
        { label: 'Delivered', value: Shell.formatNumber(stats.sent) },
        { label: 'Failed', value: Shell.formatNumber(stats.failed), tone: stats.failed > 0 ? 'bad' : '' },
        { label: 'Waiting', value: Shell.formatNumber(stats.queued) },
        { label: 'Skipped', value: Shell.formatNumber(stats.skipped),
          sub: 'unsubscribed or left the segment before their turn' },
        { label: 'Unique opens', value: Shell.formatNumber(stats.uniqueOpens),
          sub: Shell.formatPercent(stats.openRate) + ' of delivered' },
        { label: 'Unique clicks', value: Shell.formatNumber(stats.uniqueClicks),
          sub: Shell.formatPercent(stats.clickRate) + ' of delivered' },
        { label: 'Click-to-open', value: Shell.formatPercent(stats.clickToOpenRate) },
        { label: 'Unsubscribes', value: Shell.formatNumber(stats.unsubscribes),
          tone: stats.unsubscribes > 0 ? 'warn' : '' }
      ];

      var tilesHtml = _.map(tiles, function (tile) {
        return '<div class="mlg-tile ' + (tile.tone || '') + '">' +
          '<div class="t-value">' + tile.value + '</div>' +
          '<div class="t-label">' + _.escape(tile.label) + '</div>' +
          (tile.sub ? '<div class="t-sub">' + _.escape(tile.sub) + '</div>' : '') +
          '</div>';
      }).join('');

      var urls = stats.topUrls || [];
      var urlsHtml = urls.length ?
          '<table class="mlg-table compact">' +
          '<thead><tr><th>Link</th><th class="num">Clicks</th><th class="num">Unique</th></tr></thead>' +
          '<tbody>' + _.map(urls, function (row) {
            return '<tr>' +
              '<td class="c-url" title="' + _.escape(row.url || '') + '">' +
                _.escape(row.url || '') + '</td>' +
              '<td class="num">' + Shell.formatNumber(row.clicks) + '</td>' +
              '<td class="num">' + Shell.formatNumber(row.uniqueClicks) + '</td>' +
              '</tr>';
          }).join('') + '</tbody></table>' :
          Shell.emptyHtml('No link has been clicked yet.');

      this.ui.body.html(
        '<div class="mlg-detail-head">' +
        '  <h2>' + _.escape(campaign.name || '') + '</h2>' +
        '  <div class="d-sub">' + _.escape(campaign.subject || '') + '</div>' +
        '  <div class="d-meta">' +
             '<span class="mlg-chip st-' + (campaign.status || 'DRAFT').toLowerCase() + '">' +
               Shell.prettyCase(campaign.status) + '</span>' +
             '<span>Template: ' + _.escape(campaign.templateName || '—') + '</span>' +
             '<span>Segment: ' + _.escape(campaign.segmentName || '—') + '</span>' +
             (campaign.sentAt ? '<span>Sent ' + Shell.formatDate(campaign.sentAt, true) + '</span>' : '') +
        '  </div>' +
        '</div>' +
        '<div class="mlg-tiles">' + tilesHtml + '</div>' +
        '<h3 class="mlg-section">Most clicked links</h3>' + urlsHtml);
    },

    onBack: function (e) {
      e.preventDefault();
      App.navigate('mailing/campaigns', { trigger: true });
    }
  });

  module.exports = CampaignDetailView;
});

